import { service } from "./self-provider.service";
import { createUseData } from "../../../common/hooks/create-use-data/create-use-data";

export const useSelf = createUseData(service.getSelf)